import React from "react";
import {
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  TableBody,
  Paper,
  LinearProgress,
  Typography,
  Chip,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import style from "../CampaignDetails/Campaign.module.css";

const columns = [
  {
    field: "CAMPAIGN",
    headerName: "CAMPAIGN",
    width: 10,
  },
  { field: "TIMELINE", headerName: "TIMELINE", width: 20 },

  { field: "Campaign Owner", headerName: "CAMPAIGN OWNER", width: 60 },
  { field: "PROGRESS", headerName: "PROGRESS", width: 20 },
];

const rows = [
  {
    CAMPAIGN: "Trival Art Campaign 2024",
    TIMELINE: "24 sept 2024-30 oct 2024",
    OWNER: "Manish",
    ADDRESS: "TIGAON",
    PROGRESS: 85,
  },
  {
    CAMPAIGN: "Trival Art Campaign 2024",
    TIMELINE: "24 sept 2024-30 oct 2024",
    OWNER: "Rakesh",
    ADDRESS: "TIGAON",
    PROGRESS: 85,
  },
  {
    CAMPAIGN: "Trival Art Campaign 2024",
    TIMELINE: "24 sept 2024-30 oct 2024",
    OWNER: "Rohit",
    ADDRESS: "TIGAON",
    PROGRESS: 85,
  },
  {
    CAMPAIGN: "Trival Art Campaign 2024",
    TIMELINE: "24 sept 2024-30 oct 2024",
    OWNER: "Ravi",
    ADDRESS: "TIGAON",
    PROGRESS: 85,
  },
  {
    CAMPAIGN: "Trival Art Campaign 2024",
    TIMELINE: "24 sept 2024-30 oct 2024",
    OWNER: "Mohit",
    ADDRESS: "TIGAON",
    PROGRESS: 85,
  },
  {
    CAMPAIGN: "Trival Art Campaign 2024",
    TIMELINE: "24 sept 2024-30 oct 2024",
    OWNER: "85",
    ADDRESS: "TIGAON",
    PROGRESS: 85,
  },
  {
    CAMPAIGN: "Trival Art Campaign 2024",
    TIMELINE: "24 sept 2024-30 oct 2024",
    OWNER: "85",
    ADDRESS: "TIGAON",
    PROGRESS: 85,
  },
  // Add more rows as needed
];

const OnGoingCampaigns = ({ ongoingCampaign }) => {
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "short" }); // short month format (e.g., Oct)
    const year = date.getFullYear().toString().slice(-2); // last two digits of the year

    return `${day} ${month} ${year}`;
  };
  const filterOngoingCampaign = ongoingCampaign.filter(
    (ele) => ele.progress < 100,
  );

  return (
    <Grid className="bg-[var(--secondary-color)] min-h-[420px] w-full  p-2 rounded-md shadow-lg">
      <div className="flex flex-col   lg:flex-row justify-between items-center gap-7">
        <div className="text-black text-xl font-bold mb-4 p-4">
          <h2 className="text-lg font-semibold">Ongoing Campaigns</h2>
        </div>
        <Chip
          label={filterOngoingCampaign?.length}
          sx={{
            backgroundColor: "#FFD98E", // Custom background color
            color: "#C77903", // Custom text color
          }}
        />
        {/* <Search color="var(--listdown-color)" />
          <input
            type="text"
            className="outline-none w-full"
            placeholder={`Search Campaign`}
          /> */}
      </div>

      <TableContainer
        sx={{
          height: 360,
          overflowY: "auto",
        }}
        className={`mt-2 rounded-lg ${style["custom-scrollbar"]}`}
      >
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              {columns?.map((column) => (
                <TableCell
                  key={column.field}
                  sx={{
                    fontWeight: "bold",
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    backgroundColor: "#fff",
                  }}
                >
                  <span>{column.headerName}</span>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {filterOngoingCampaign?.map((row, index) => (
              <TableRow key={index}>
                <TableCell>
                  {row?.campaignTitle.charAt(0).toUpperCase() +
                    row?.campaignTitle.slice(1)}
                </TableCell>
                <TableCell>
                  {formatDate(row?.startDate)} - {formatDate(row?.endDate)}
                </TableCell>{" "}
                <TableCell align="left">
                  <div>{row?.campaignOwnerId?.name}</div>
                  <div className="text-gray-400 text-xs">{row?.ADDRESS}</div>
                </TableCell>
                <TableCell align="left">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <LinearProgress
                      variant="determinate"
                      value={row?.progress}
                      sx={{
                        height: 10,
                        borderRadius: 5,
                        backgroundColor: "rgba(0, 0, 0, 0.1)",
                        flexGrow: 1,
                        marginRight: "10px",
                      }}
                    />
                    <Typography variant="body2" color="textSecondary">
                      {Math.round(row?.progress)}%
                    </Typography>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default OnGoingCampaigns;
